export enum PrescriptionStatus {
    Draft = 1,
    Prescribed,
    Archived,
    StoredLocal = 4,
    WalkInDraft = 5
}
